import React from "react";
import { Typography } from "@mui/material";
import { PageContainer, PageContent } from "../../components/wraper";
const SettingsPage = () => {
    return (React.createElement(PageContainer, null,
        React.createElement(PageContent, null,
            React.createElement(Typography, { variant: "h2", component: "h1", gutterBottom: true }, "Settings"),
            React.createElement(Typography, { variant: "body1", color: "text.secondary" }, "This is the Settings page. Here you can configure system settings."))));
};
export default SettingsPage;
